import FontPreload from './FontPreload';

export default FontPreload;
